import {createHtmlElement} from "../../../functions";
import {isDesktop, isMobile} from "../../../settings";

import { changeLangToCurrent } from '../../components/langSwitcher/langSwitcher';

import QRCode from 'qrcode';
import { setLordIcon } from '../../../lordicon';

export const openGetApp =  async (container) => {
    const {qrCodeUrl,appStoreUrl,googlePlayUrl} = config.getApp;

    if (isMobile){
        window.open(qrCodeUrl,'_blank');
        return;
    }

    await createGetApp(qrCodeUrl,appStoreUrl,googlePlayUrl,container);
}

async function createGetApp(qrCode,appStoreLink,googlePlayLink,container) {
    const main = createHtmlElement(container,'','div',['get-app', 'background-backdrop-filter']);
    const contentContainer = createHtmlElement(main,'','div',['get-app__content-container']);

    if (isDesktop){
        const title = createHtmlElement(contentContainer,changeLangToCurrent('getAppTitleDesktop'),'h2',['get-app__title','language-string']);
        title.setAttribute('data-dictionary', 'getAppTitleDesktop');
    } else {
        const title = createHtmlElement(contentContainer,changeLangToCurrent('getAppTitle'),'h2',['get-app__title','language-string']);
        title.setAttribute('data-dictionary', 'getAppTitle');
    }

    if (qrCode){

        const scanIcon = createHtmlElement(contentContainer,'','div',['get-app__scan__icon']);
        setLordIcon('scanIcon',scanIcon,{
            stroke: 70
        });
        const qrCodeWrapper = createHtmlElement(contentContainer,'','div',['get-app__qr-code__wrapper']);

        await QRCode.toDataURL(qrCode, function (err, url) {
            qrCodeWrapper.style.backgroundImage = `url(${url})`;
        });
    }

    const btnWrapper = createHtmlElement(contentContainer,'','div',['get-app__btn-container']);

    if (isDesktop){
        btnWrapper.classList.add('hidden');
    }

    if (appStoreLink){
        const iosLink = createHtmlElement(btnWrapper,'','a',['get-app__link']);
        iosLink.href=appStoreLink;
        iosLink.setAttribute('target','_blank');
        const iosBtn = createHtmlElement(iosLink,'','img',['get-app__btn']);
        iosBtn.src='./img/appstore_button.svg';
    }

    if (googlePlayLink){
        const androidLink = createHtmlElement(btnWrapper,'','a',['get-app__link']);
        androidLink.href=googlePlayLink;
        androidLink.setAttribute('target','_blank');
        const androidBtn = createHtmlElement(androidLink,'','img',['get-app__btn']);
        androidBtn.src='./img/google_play_button.svg';
    }

    return main;
}


// window.getQRCode = async (link,fileName) => {
//     await QRCode.toDataURL(link, function (err, url) {
//         const a = document.createElement('a');
//         a.download = fileName;
//         a.href = url;
//         a.click();
//     });
// }
